
export const state = {
    loading: false,
    produk: {},
    produk:[],
    columns: [],
    paginate: {total:0},
    resp: {}
  }
  export const mutations = {
    LOADING: (state) => {
      state.loading = true
    },
    PRODUK: (state, payload) => {
      state.produk = payload
      state.loading = false
    },
    LOGIN: (state, payload) => {
      state.produk_session = payload
      state.loading = false
    },
    SET_PRODUKS: (state, payload) => {
      state.loading = false
      state.paginate = payload.pagination
      state.produks = payload.data
    },
    SET_COLUMNS: (state, payload) => {
      state.loading = false
      state.columns = payload
    },
    SET_RESP: (state, payload) => {
      state.loading = false
      state.resp = payload
    },
  
  }
  
  export const actions = {
    POST_PRODUK: async({commit}, payload) => {
      commit("LOADING")
      return await axios({url: 'api/produk', data: payload, method: 'POST'})
          .then(resp => {
              if(resp.data.code == 200) {
                  commit("SET_PRODUKS", resp.data.data)
              } else {
                  commit("SET_RESP", resp.data)
              }
              return resp
          })
  },
    GET_PRODUK: async({commit}, args) => {
      commit("LOADING")
        console.log('args ',args)
      var params = queryString.stringify({
        ...{
            limit: 10,
            page: args.page,
            name: null,
            sort: '-id'
        }, ...args}
      )
      return await axios({url: 'api/produk?' + args.params, method: 'GET'})
        .then(resp => {
          if(resp.data.status == '200 OK') {
            commit("SET_PRODUK", resp.data)
          }
          return resp
        })
    },
    GET_COLUMNS: async({commit}) => {
      commit("LOADING")
      return await axios({url: 'api/produk/columns' , method: 'GET'})
        .then(resp => {
          if(resp.data.status == 'success') {
            commit("SET_COLUMNS", resp.data.data)
          }
          return resp
        })
    },
    DELETE_PRODUK: async({commit},cutomerId) => {
      commit("LOADING")
      return await axios({url: 'api/produk/'+cutomerId, method: 'DELETE'})
         .then(resp => {
              if(resp.data.code == 200) {
                      swal({
                          type: 'success',
                          title: 'Status...',
                          text: resp.data.message
                      })
                  commit("SET_RESP", resp.data)
  
        }
        return resp
      })
  
  
    },
  
  }
  
  export const getters = {
    produk: state => state.produk,
    produks: state => state.produks,
    paginate: state => state.paginate,
    isLoading: state => state.loading,
    resp: state => state.resp,
    columns: state => state.columns
  }
  
  // export default {
  //   // namespaced: true,
  //   state,
  //   getters,
  //   actions,
  //   mutations,
  //
  // }
  